// frontend/user/src/_lib/discover-api.ts
// 分类树(v_category_public)hook — 首页文章流分类筛 + 文章编辑器分类选择共用。
//
// 2026-06-02(D4):公开文件/包发现移除,首页改文章流。原 usePublicPacks /
// usePublicFiles(public-file-api)已删;本文件仅保留分类树。
// 2026-06-05(module spec):Category/CategoryTree 加 module 字段;usePublicCategories 支持 module 过滤参数。
import { useQuery } from '@tanstack/react-query'
import { getSupabase } from '@dogdisk/shared'

export type Module = 'forum' | 'dating' | 'game'

export type Category = {
  id: string
  name: string
  parent_id: string | null
  sort_order: number
  module: string | null // 视图 computed:一级=自身,二级=父级
}

export type CategoryTree = {
  id: string
  name: string
  module: string | null
  children: Array<{ id: string; name: string }>
}

/** 分类树;传 module 时只返回该模块的一级(及其二级)。 */
export function usePublicCategories(module?: Module) {
  return useQuery({
    queryKey: ['discover', 'categories', module ?? 'all'] as const,
    queryFn: async (): Promise<CategoryTree[]> => {
      const sb = getSupabase()
      const { data, error } = await sb
        .from('v_category_public')
        .select('id,name,parent_id,sort_order,module')
        .order('sort_order', { ascending: true })
      if (error) throw error
      const rows = (data ?? []) as Category[]
      const l1 = rows.filter(
        (r) => r.parent_id === null && (!module || r.module === module),
      )
      return l1.map((p) => ({
        id: p.id,
        name: p.name,
        module: p.module,
        children: rows
          .filter((r) => r.parent_id === p.id)
          .map((c) => ({ id: c.id, name: c.name })),
      }))
    },
  })
}
